import React, { useContext, useState, useEffect } from 'react';
import Styled from 'styled';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Switch, Route, RouteComponentProps } from 'react-router';

import { Site } from 'four-nets/site';
import NotFound from 'four-nets/errors/404/not-found';
import Unauthorized from 'four-nets/errors/401/unauthorized';
import { ViewerContext } from 'four-nets/user/viewer/viewer';
import SubNavigation from 'four-nets/ui-v2/sub-navigation/sub-navigation';

import SettingsWedding from './wedding/settings-wedding';
import SettingsNotifications from './notifications/settings-notifications';
import ProfileAndAccountWrapper from './settings-profile-and-account/settings-profile-and-account';

import defaultStyles from './settings-router.scss';

interface Props extends RouteComponentProps<{ username: string }> {
    styles: typeof defaultStyles;
}

const SettingsRouter: React.FC<Props> = (props, context) => {
    const {
        styles,
        match: {
            params: { username },
        },
    } = props;

    const { site } = context || {};
    const { viewer } = useContext(ViewerContext);

    const [links, setLinks] = useState<
        Array<{
            label: React.ReactNode | string;
            to: string;
            path: string;
            component: React.ComponentClass<any, any> | React.FunctionComponent<any>;
        }>
    >([]);

    useEffect(() => {
        // tslint:disable-next-line: variable-name
        const _links = [
            {
                label: <FormattedMessage id='PROFILE' />,
                to: `/settings/${viewer && viewer.username}/`,
                path: '/settings/:username',
                component: ProfileAndAccountWrapper,
            },
            {
                label: <FormattedMessage id='NOTIFICATIONS' />,
                to: `/settings/${viewer && viewer.username}/notifications/`,
                path: '/settings/:username/notifications',
                component: SettingsNotifications,
            },
        ];

        if (site.isWedding && viewer && !viewer.profile.vendor) {
            _links.splice(1, 0, {
                label: <FormattedMessage id='WEDDING' />,
                to: `/settings/${viewer && viewer.username}/wedding/`,
                path: '/settings/:username/wedding',
                component: SettingsWedding as any,
            });
        }
        setLinks(_links);
    }, [viewer, site]);

    if (!viewer || viewer.username !== username) {
        return <Unauthorized />;
    }

    return (
        <div className={styles.settingsWrapper}>
            <FormattedMessage id='ACCOUNT_SETTINGS'>{msg => <h1 className={styles.header}>{msg}</h1>}</FormattedMessage>
            <SubNavigation style={{ subNavigation: styles.subNavigationSubNavigation }} links={links} />
            <Switch>
                {links.map(({ component, path }) => (
                    <Route key={path} exact={true} component={component} path={path} />
                ))}
                <Route component={NotFound} />
            </Switch>
        </div>
    );
};

SettingsRouter.contextTypes = {
    site: PropTypes.instanceOf(Site),
};

export default Styled(defaultStyles)(SettingsRouter);
